import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export const authenticationProviderOptionStyle: React.CSSProperties = {
    marginBottom: CommonStyles.Sizes.NormalFontSize
};

export const authenticationProviderOptionDescriptionStyle: React.CSSProperties = {
    fontSize: CommonStyles.Sizes.SmallFontSize,
    paddingTop: '4px'
};

export const authenticationProviderOptionTitleStyle: React.CSSProperties = {
    fontFamily: 'BentonSans-Medium',
    fontWeight: 500
};

export const authenticationProviderOptionListItem: React.CSSProperties = {
    padding: '8px 8px',
    whiteSpace: 'normal',
    borderRadius: '2px'
};

export const configureAuthenticationLinkStyle: React.CSSProperties = {
    fontSize: CommonStyles.Sizes.SmallFontSize
};

export const authenticationRadioButtonsStyle: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.DefaultSpace,
    marginBottom: CommonStyles.Sizes.NormalFontSize
};